import { useLocale } from '@bluebeam/react-i18n';
import { environmentVars } from 'constants/services';
import React, { useEffect, useState } from 'react';
import { hotjar } from 'react-hotjar';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';
import './Index.css';
import { useLanguageOptions } from 'hooks/useLanguageOptions';
import FeaturesSection from './Index/FeaturesSection';
import Hero from './Index/Hero';
import Interstitial from './Index/Interstitial';
import SignInSection from './Index/SignInSection';
import IndexFooter from './IndexFooter';
import IndexHeader from './IndexHeader';
import AtlasRedirectedModal from './AtlasRedirectedModal';

interface Props extends WithAppStoreProps, RouteComponentProps {}

const IndexPage = (props: Props) => {
  /*
    Due to a bug in Identity (ID-1) we are routing all "Sign Up" users
    to the BBID sign-in page. Keeping the below logic for when the bug
    gets fixed.
  */

  const [serialNumber, setSerialNumber] = useState('');
  const { languageCode, setLanguageCode } = useLocale();
  const [hideModal, setHideModal] = useState<boolean>(false);
  const { languageOptions } = useLanguageOptions();

  const isAvailableLanguage = (lng: string): boolean => {
    return languageOptions.some((language) => language.value === lng);
  };

  const init = async (): Promise<void> => {
    const qp = getQueryParams();

    if (qp.length > 0) {
      const queryParams = new URLSearchParams(props.location.search);
      const sn = queryParams.get('x-bb-sn');
      const c = queryParams.get('x-bb-created');
      const created = parseInt(c || '0', 10);
      const e = queryParams.get('x-bb-expires');
      const expires = parseInt(e || '300', 10);
      const signature = queryParams.get('x-bb-sig');
      const lng = queryParams.get('lng');

      if (isAvailableLanguage(lng as string)) {
        setLanguageCode(lng as string);
      }

      await new Promise((r) => setTimeout(r, 1000));

      const responseStatus: Response = await fetch(
        `${environmentVars.API_GATEWAY_ENDPOINT}/entstatus`,
        {
          method: 'POST',
          mode: 'cors',
          cache: 'no-cache',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            sn,
            created,
            expires,
            signature,
          }),
        }
      );

      if (responseStatus.ok) {
        const jsonStatus = await responseStatus.json();

        setSerialNumber(jsonStatus.sn);
      }
    }

    hotjar.initialize(197358, 6);
  };
  useEffect(() => {
    init();
  });

  const getQueryParams = (): string => {
    const queryParams = new URLSearchParams(window.location.search);
    const sn = queryParams.get('x-bb-sn');
    const qp = sn ? `?sn=${sn}` : '';

    return qp;
  };
  const qp = serialNumber.length > 0 ? `?sn=${serialNumber}` : '';

  const showAtlasModal = (): boolean => {
    const queryParams = new URLSearchParams(props.location.search);
    return queryParams.get('msg') === 'atlas';
  };

  const handleClose = (): void => {
    setHideModal(!hideModal);
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        position: 'fixed',
        inset: 0,
        overflowY: 'auto',
      }}
    >
      {showAtlasModal() && !hideModal ? (
        <AtlasRedirectedModal onCloseClick={handleClose} />
      ) : null}
      <IndexHeader queryParams={qp} />
      <Hero queryParams={qp} />
      {Boolean(environmentVars.BB_BRANDING) === false && (
        <>
          <Interstitial />
          <FeaturesSection />
          <SignInSection queryParams={qp} />
        </>
      )}
      <IndexFooter />
    </div>
  );
};

export default withRouter(withAppStore<Props>(IndexPage));
